import {otsBaseApi} from "../../ots-api";
import {PipelineFlow, PipelineFlowSearchCriteria} from "../../../model/pipeline/pipeline-flow";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["PipelineFlows"]});

const pipelineFlowApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchPipelineFlows: builder.query<
      PipelineFlow[],
      PipelineFlowSearchCriteria
    >({
      query: (criteria) => ({
        url: `/pipeline-flow/search`,
        method: 'POST',
        body: criteria,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "PipelineFlows", id} as const)),
            {type: "PipelineFlows", id: "LIST"}
          ];
        } else {
          return [{type: "PipelineFlows", id: "LIST"}];
        }
      },
    }),
    getPipelineFlow: builder.query<PipelineFlow, string>({
      query: (id) => ({
        url: `/pipeline-flow/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "PipelineFlows", id}]
    }),
    createPipelineFlow: builder.mutation<PipelineFlow, Partial<PipelineFlow>>({
      query: (mapping) => ({
        url: "/pipeline-flow",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "PipelineFlows", id: "LIST"}]
    }),
    updatePipelineFlow: builder.mutation<PipelineFlow, Partial<PipelineFlow>>({
      query: (mapping) => ({
        url: "/pipeline-flow",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "PipelineFlows", id}]
    }),
    deletePipelineFlow: builder.mutation<void, Partial<PipelineFlow>>({
      query: (mapping) => ({
        url: "/pipeline-flow",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "PipelineFlows", id}]
    })
  })
});

export const {
  useSearchPipelineFlowsQuery,
  useGetPipelineFlowQuery,
  useCreatePipelineFlowMutation,
  useUpdatePipelineFlowMutation,
  useDeletePipelineFlowMutation,
} = pipelineFlowApi;
